/* eslint-disable react-hooks/exhaustive-deps */
import { Link, Outlet } from 'react-router-dom';
import './styles/profile.css';

export default function Profile({slidBarPOsition, setSlidBarPOsition, setProfileActive, profileActive}) {
  const handleActive = (position, activeBtn) =>{
    setSlidBarPOsition(position)
    setProfileActive(activeBtn)
}
  return (
    <div className='profile__wrap'>
      <nav>
        <Link className={`profile__nav__link ${profileActive === "profileInfo" ? "active_text" : ""}`} to="/profile" onClick={() =>handleActive(0, "profileInfo")}>
          <div className="profile__link-icon-profile profile__link-icon" />
          <div className="profile__link-text">我的檔案</div>
        </Link>
        <Link className={`profile__nav__link ${profileActive === "orderhistory" ? "active_text" : ""}`} to="/profile/orderhistory" onClick={() =>handleActive("calc(100% / 3 *1)", "orderhistory")}>
          <div className="profile__link-icon-orderhistory profile__link-icon" />
          <div className="profile__link-text">已完成訂單</div>
        </Link>
        <Link className={`profile__nav__link ${profileActive === "favoritelist" ? "active_text" : ""}`} to="/profile/favoritelist" onClick={() =>handleActive("calc(100% / 3 *2)", "favoritelist")}>
          <div className="profile__link-icon-favorite profile__link-icon" />
          <div className="profile__link-text">按讚好物</div>
        </Link>
      </nav>
      <div className='nav__slid__bar'>
        <span style={{left: slidBarPOsition}}></span>
      </div>
      
      <Outlet />
    </div>
  );
}
